import { BqTag } from '~/components/ui/misc/bqTag/BqTag';

export function InvestorCellAg(props: { value: string }) {
  if (!props.value) {
    return '-';
  }
  return <BqTag color="info" value={props.value} />;
}
